interface HeadersHolder {
  headers?: Headers;
}

// `headers` is a Map, which can't be stringified for postMessage. Thus, we
// convert to a plain object.
export const formatHeadersForPostMessage = <T extends HeadersHolder>(
  headersHolder: T
) => {
  if (!headersHolder.headers) {
    return headersHolder;
  }

  const rawHeaders = {};
  headersHolder.headers.forEach((value, key) => {
    rawHeaders[key] = value;
  });

  return {
    // type assertion required due to TypeScript bug when spreading generic types
    // https://github.com/Microsoft/TypeScript/pull/13288
    ...(headersHolder as HeadersHolder),
    headers: rawHeaders,
  };
};
